/** Read a dotted path; numeric segments traverse arrays. */
export function getAtPath(obj: unknown, path: string): unknown {
  let cur: unknown = obj;
  for (const key of path.split(".")) {
    if (cur == null) return undefined;
    if (Array.isArray(cur)) {
      const idx = Number(key);
      if (!Number.isInteger(idx) || idx < 0) return undefined;
      cur = cur[idx];
    } else if (typeof cur === "object") {
      cur = (cur as Record<string, unknown>)[key];
    } else return undefined;
  }
  return cur;
}

/** Set a leaf on a patch object (mutates). Creates objects/arrays along the path. */
export function setAtPath(root: Record<string, unknown>, path: string, value: unknown): void {
  const keys = path.split(".");
  const lastKey = keys.pop();
  if (lastKey === undefined) return;

  let cur: unknown = root;
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]!;
    const nextKey = keys[i + 1];
    if (Array.isArray(cur)) {
      const idx = Number(key);
      if (!Number.isInteger(idx) || idx < 0) return;
      const arr = cur as unknown[];
      while (arr.length <= idx) arr.push({});
      cur = arr[idx];
    } else {
      const o = cur as Record<string, unknown>;
      const v = o[key];
      if (v == null || typeof v !== "object" || Array.isArray(v)) {
        const needArr = nextKey !== undefined && /^\d+$/.test(nextKey);
        o[key] = needArr ? [] : {};
      }
      cur = o[key];
    }
  }

  if (Array.isArray(cur)) {
    const idx = Number(lastKey);
    if (!Number.isInteger(idx) || idx < 0) return;
    const arr = cur as unknown[];
    while (arr.length <= idx) arr.push(undefined);
    arr[idx] = value;
    return;
  }
  (cur as Record<string, unknown>)[lastKey] = value;
}
